export default "__VITE_ASSET__Bj_QGLcn__"